import {Component, Input, OnInit} from '@angular/core';
import {ConfigService} from '../../core/services/config/config.service';
import {ComponentConfiguration} from '../../core/models/config';
import {AccessiblePaletteService} from '../../core/services/accessible-palette/accessible-palette.service';

@Component({
    selector: 'app-capacity-chart',
    templateUrl: './capacity-chart.component.html',
    styleUrls: ['./capacity-chart.component.scss']
})
export class CapacityChartComponent implements OnInit {
    @Input() capacityData: any;
    @Input() height?: number;
    public chartConfig: ComponentConfiguration;
    public defaultChartPopupSettings = {
        popupClass: ['wide-chart-tooltip-settings ']
    };
    private defaultConfig = {
        id: 'capacity',
        name: 'Capacity Chart',
        type: 'chart',
        config: {
            metric: {
                capacity: {
                    name: 'Capacity',
                    style: {color: '#05FF8E'}
                },
                allocation: {
                    name: 'Allocation',
                    style: {color: '#FC6F60'}
                },
                excess: {
                    name: 'Excess',
                    style: {color: '#0B3EF9'}
                },
                flexFcst: {
                    name: 'Flex Forecast',
                    style: {color: '#E6E7E8'}
                },
                walkUpDmd: {
                    name: 'Walk-Up Demand',
                    style: {color: '#C7C7C7'}
                },
                walkUpOvr: {
                    name: 'Walk-Up Override',
                    style: {color: '#05053A'}
                }
            }
        }
    };

    // Brand palette plus one accent; per-series border ink is what keeps the weak seams readable (RLP-4323)
    private accessibleColors = {
        capacity: '#05053A',
        allocation: '#0B3EF9',
        excess: '#101D91',
        flexFcst: '#71E2AF',
        walkUpDmd: '#E6E7E8',
        walkUpOvr: '#D55E00'
    };

    // One stable object per series: Kendo re-pushes the chart on every input change
    private accessibleBorders: {[metric: string]: {color: string, width: number}} = {
        allocation: {color: '#FFFFFF', width: 1},
        excess: {color: '#FFFFFF', width: 1},
        flexFcst: {color: '#05053A', width: 1},
        walkUpDmd: {color: '#05053A', width: 1},
        walkUpOvr: {color: '#05053A', width: 1}
    };

    constructor(private configService: ConfigService, private paletteSvc: AccessiblePaletteService) {
        const config = this.configService.getComponentConfiguration('inventory', 'capacity');
        this.chartConfig = config ? config : this.defaultConfig;
    }

    ngOnInit(): void {
    }

    public seriesColor(metric: string): string {
        return this.paletteSvc.isEnabled()
            ? this.accessibleColors[metric]
            : this.chartConfig.config.metric[metric].style.color;
    }

    public seriesBorder(metric: string): {color: string, width: number} {
        return this.paletteSvc.isEnabled() ? this.accessibleBorders[metric] : undefined;
    }

}
